import {ApiConfig} from "@/models/api-config";

export const apiConfig = new ApiConfig();